import { API } from "../auth/authApi";

export const getChatRequestsApi = (params) => {
    return API.get("/chat/request/admin", { params });
};